// src/pages/SplashScreen.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Typography, Avatar } from '@mui/material';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'; 

import { CenterContent, VList } from '../utils/layouts';
import Loader from '../utils/Loader';

const SplashScreen = () => {
  const navigate = useNavigate();
  const teacher = useSelector((state) => state.session?.teacher);
  
  const [show, setShow] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const runSplashSequence = async () => {
      await new Promise(resolve => setTimeout(resolve, 100));
      if (!isMounted) return;
      
      // تشغيل الدخول الدرامي
      setShow(true);

      // وقت عرض الشاشة
      await new Promise(resolve => setTimeout(resolve, 5500));
      if (!isMounted) return;

      // تشغيل حركة الخروج التناثرية
      setShow(false);

      await new Promise(resolve => setTimeout(resolve, 800));
      if (isMounted) {
        navigate('/', { replace: true });
      }
    };

    runSplashSequence();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  // --- دوال الحركات الصاخبة (Noisy Animations) ---
  
  // 1. حركة الصورة: دوران 360 درجة مع ارتداد عنيف (Extreme Spring)
  const avatarAnim = {
    opacity: show ? 1 : 0,
    transform: show ? 'scale(1) rotate(0deg)' : 'scale(0) rotate(-360deg)',
    transition: `all 0.9s cubic-bezier(0.68, -0.6, 0.32, 1.6) ${show ? 100 : 0}ms`,
  };

  // 2. حركة النص الأول: اندفاع من أقصى اليمين
  const textRightAnim = {
    opacity: show ? 1 : 0,
    transform: show ? 'translateX(0)' : 'translateX(100vw)',
    transition: `all 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6) ${show ? 300 : 100}ms`,
  };

  // 3. حركة النص الثاني: اندفاع من أقصى اليسار
  const textLeftAnim = {
    opacity: show ? 1 : 0,
    transform: show ? 'translateX(0)' : 'translateX(-100vw)',
    transition: `all 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6) ${show ? 450 : 200}ms`,
  };

  // 4. حركة التحميل: انبثاق مفاجئ من الأسفل
  const loaderAnim = {
    opacity: show ? 1 : 0,
    transform: show ? 'translateY(0) scale(1)' : 'translateY(150px) scale(0)',
    transition: `all 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) ${show ? 700 : 300}ms`,
  };

  return (
    <CenterContent minHeight="100vh" >
      
      {/* استخدمنا overflow hidden لكي لا تظهر أشرطة التمرير أثناء اندفاع النصوص من خارج الشاشة */}
      <VList gap={2} sx={{ alignItems: 'center', textAlign: 'center', width: '100%', overflow: 'hidden', px: 2 }}>
        
        {/* الصورة الشخصية */}
        <Box sx={{ ...avatarAnim, display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Avatar
            src={teacher?.image || undefined}
            alt={teacher?.name || 'تربو'}
            sx={{
              width: 150, // كبرناها قليلاً لمزيد من لفت الانتباه
              height: 150,
              boxShadow: (theme) => `0 15px 35px ${theme.palette.custom.badgeBg}`,
              border: '5px solid',
              borderColor: 'primary.main',
              bgcolor: 'custom.glassBg',
              color: 'primary.main',
            }}
          >
            {!teacher?.image && <PersonRoundedIcon sx={{ fontSize: 90 }} />}
          </Avatar>
        </Box>

        {/* نص الترحيب */}
        <Typography 
          variant="pageTitle" 
          sx={{ 
            fontSize: '2.5rem', 
            ...textRightAnim 
          }}
        >
          أهلاً بك
        </Typography>
        
        {/* اسم المستخدم */}
        <Typography 
          variant="sectionTitle" 
          sx={{ 
            fontSize: '1.4rem',
            color: 'primary.main', // تلوين الاسم للفت الانتباه
            ...textLeftAnim 
          }}
        >
          {teacher?.name ? `التربوي / ${teacher.name}` : 'جاري تحميل البيانات...'}
        </Typography>

        {/* مؤشر التحميل */}
        <Box sx={{ mt: 4, ...loaderAnim }}>
          <Loader text="جاري تجهيز بيئة العمل..." size={40} />
        </Box>

      </VList>

    </CenterContent>
  );
};

export default SplashScreen;